/* import __COLOCATED_TEMPLATE__ from './pii-reveal-button.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type PiiService from 'embercom/services/pii-service';

interface Args {
  userId?: string;
  field: 'email' | 'phone';
  onReveal: (value: string) => void;
  sourceType?: 'phone_call_redirect';
  sourceId?: string;
}

interface Signature {
  Args: Args;
  Element: HTMLButtonElement;
}

export default class PiiRevealButton extends Component<Signature> {
  @service declare piiService: PiiService;

  @tracked isRevealing = false;

  get isVisible(): boolean {
    return this.piiService.canRevealMaskedData;
  }

  @action
  async reveal() {
    let { userId, sourceType, sourceId, field } = this.args;

    if (this.isRevealing) {
      return;
    }

    if (!userId && !(sourceType && sourceId)) {
      return;
    }

    this.isRevealing = true;
    try {
      let value: string | null;
      if (sourceType === 'phone_call_redirect' && sourceId) {
        value = await this.piiService.revealSwitchCaller(sourceId, field);
      } else {
        value = await this.piiService.revealField(userId!, field);
      }
      if (value !== null) {
        this.args.onReveal(value);
      }
    } catch (error) {
      console.error('Failed to reveal PII', error);
    } finally {
      this.isRevealing = false;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::PiiRevealButton': typeof PiiRevealButton;
    'inbox2/conversation-details-sidebar/sidebar-sections/pii-reveal-button': typeof PiiRevealButton;
  }
}
